import Fuse, { type FuseResult } from 'fuse.js';
import { components } from '../api-abcscale';
import { apiPost, ApiCallbacks } from '../apiClient';

type SkuSearchIndexEntry = components['schemas']['SkuSearchIndexEntry'];

let cachedFuse: Fuse<SkuSearchIndexEntry> | null = null;

export async function loadSkuSearchIndex(): Promise<Fuse<SkuSearchIndexEntry>> {
  if (cachedFuse) return cachedFuse;

  const res = await fetch('/data/sku/search-index.json');
  if (!res.ok) throw new Error(`HTTP ${res.status}`);

  const data: SkuSearchIndexEntry[] = await res.json();

  cachedFuse = new Fuse(data, {
    keys: [
      { name: 'part_number', weight: 2 },
      { name: 'description', weight: 1 },
    ],
    threshold: 0.3,
    distance: 200,
    minMatchCharLength: 3,
    ignoreLocation: true,
    includeMatches: true,
  });

  return cachedFuse;
}

export function searchSkuIndex(
  fuse: Fuse<SkuSearchIndexEntry>,
  query: string,
): FuseResult<SkuSearchIndexEntry>[] {
  if (!query.trim()) return [];
  return fuse.search(query, { limit: 100 });
}

const SKU_BASE = `${process.env.REACT_APP_ADMIN_API_BASE ?? ''}/Sku`;

export type SkuPublishedResults = components['schemas']['SkuPublishedResults'];

export async function publishSkuSearchIndex(
  callbacks: ApiCallbacks<SkuPublishedResults>,
): Promise<void> {
  await apiPost(`${SKU_BASE}/publish-listings`, null, callbacks, true);
}
